export const TENANT_OPTIONS = [
  { value: 'security-customer-a', label: 'Security Customer A' },
];
